/* SPDX-License-Identifier: AGPL-3.0-or-later */

import { Component, Input, Output, EventEmitter } from '@angular/core';
import { TournamentEndpointService, TournamentListDto } from '@api';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConfirmationService } from '../../../services/confirmation.service';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { CopyLinkService } from 'src/app/services/copy-link.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-tournament-card',
  templateUrl: './tournament-card.component.html',
  styleUrls: ['./tournament-card.component.scss'],
  providers: [Location, { provide: LocationStrategy, useClass: PathLocationStrategy }],
})
export class TournamentCardComponent {
  @Input() tournament: TournamentListDto | undefined;
  @Output() tournamentDeleted = new EventEmitter<void>();

  constructor(
    private tournamentService: TournamentEndpointService,
    private snackBar: MatSnackBar,
    private confirmationService: ConfirmationService,
    private copyLinkService: CopyLinkService,
    private location: Location,
    private router: Router,
  ) {}

  async openConfirmDialog(): Promise<void> {
    if (
      await this.confirmationService.openConfirmationDialog(
        'delete tournament',
        'Are you sure you want to delete this tournament?',
        true,
        'Delete',
      )
    ) {
      this.deleteTournament();
    }
  }

  deleteTournament(): void {
    if (this.tournament?.id) {
      this.tournamentService.deleteTournament(this.tournament.id).subscribe({
        next: () => {
          this.snackBar.open('Tournament deleted successfully', 'Close', {
            duration: 3000,
          });
          this.tournamentDeleted.emit();
        },
        error: err => {
          console.error('Error deleting tournament', err);
          this.snackBar.open('Failed to delete tournament', 'Close', {
            duration: 3000,
          });
        },
      });
    }
  }

  openCopyTeamRegistrationLink(): void {
    const link = this.location.prepareExternalUrl(
      `#/tournaments/${this.tournament?.id}/signup?token=${this.tournament?.publicAccessToken}`,
    );

    this.copyLinkService.openDialog({ title: 'Team self-registration link', link });
  }

  overviewClicked() {
    this.router.navigate(['/admin/tournaments/', this.tournament?.id]);
  }
}
